import { FC, useMemo } from 'react';
import { RadixTable, TColumn } from '@features/ui';
import { TAccountReceiptsTable } from '@src/types/billing.ts';
import { cn, formatCurrency, formatDate } from '@lib/utils.ts';

interface AccountReceiptsProps {
  data: TAccountReceiptsTable[];
}

export const AccountReceipts: FC<AccountReceiptsProps> = ({ data }) => {
  const columns = useMemo(
    (): TColumn<TAccountReceiptsTable>[] => [
      {
        title: 'Date',
        render: (item) => (
          <p className={'font-medium'}>{formatDate(item?.paid_at, true)}</p>
        ),
      },
      {
        title: 'Billing Number',
        render: (item) => <p className={'font-medium'}>{item?.invoice_id}</p>,
      },
      {
        title: 'Account',
        render: (item) => (
          <div className={`flex flex-col gap-y-1`}>
            <div
              className={
                'min-w-[133px] w-fit max-w-full min-h-[25px] px-2 py-1 items-center justify-center flex text-[#00E579] bg-[#14CA744D] rounded-[5px] text-[10px] font-medium text-center break-words'
              }
            >
              {item?.product?.display_name_web}
            </div>
            <p className={'font-medium'}>
              {item?.external_transaction_id || ''}
            </p>
          </div>
        ),
      },
      {
        title: 'Price',
        render: (item) => (
          <p className={'font-medium'}>
            ${item?.amount ? formatCurrency(item.amount, 2) : 0}
          </p>
        ),
      },
      {
        title: 'Status',
        render: (item) => (
          <div
            className={cn(
              'flex items-center justify-center h-[26px] px-2 w-fit rounded-[5px]',
              item?.paid_at ? 'bg-[#198755]' : 'bg-[#C72E2E]'
            )}
          >
            <p className={'font-medium'}>
              {item?.paid_at ? 'Paid' : 'Un-paid'}
            </p>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div>
      <RadixTable columns={columns} data={data} />
    </div>
  );
};
